import React from 'react';
import PropTypes from 'prop-types';
import AdvTopLevelWorkflow from '../AdvWorkflow/AdvTopLevelWorkflowContainer';
import PersonalInfoWorkflow from '../PersonalInfoWorkflow/PersonalInfoWorkflowContainer';
import TaxesWorkflow from '../TaxesWorkflow/TaxesWorkflowContainer';
import IncomeWorkflow from '../IncomeWorkflow/IncomeWorkflowContainer';
import ExpensesWorkflow from '../ExpensesWorkflow/ExpensesWorkflowContainer';
import DebtManagementDebtsWorkflow from '../DebtManagementDebtsWorkflow/AccountsWorkflowContainer';
import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../js/app/react/validators';
import { useDocumentTitle } from '../../_hooks/useDocumentTitle';

const DebtManagementWorkflowView = ({
  workflowId,
  clientId,
  outputFunction,
  isMobile,
  goToSummaryWhenReady,
  shouldSkipSummary,
  ...rest
}) => {
  useDocumentTitle('Debt Management');

  return (
    <AdvTopLevelWorkflow
      {...rest}
      clientId={clientId}
      hasAutoOutput={shouldSkipSummary}
      goToSummaryWhenReady={goToSummaryWhenReady}
      workflowId={workflowId}
      analyticsWorkflowStarted="debt_management_workflow_started"
      outputFunction={outputFunction(clientId)}
      steps={[
        PersonalInfoWorkflow,
        TaxesWorkflow,
        IncomeWorkflow,
        ExpensesWorkflow,
        DebtManagementDebtsWorkflow,
      ]}
    />
  );
};

DebtManagementWorkflowView.propTypes = {
  outputFunction: PropTypes.func.isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
};

export default DebtManagementWorkflowView;
